import React, { useState } from 'react'
import './HistoryStyle.css'

const OrderCard = ({ order, formatDate }) => {
  const [showDetails, setShowDetails] = useState(false)

  const getProductName = product => {
    if (product?.product?.name) {
      const nameObj = product.product.name.find(n => n.default) || product.product.name[0]
      return nameObj?.text || 'Brak nazwy'
    }

    if (product?.name) {
      const nameObj = product.name.find(n => n.default) || product.name[0]
      return nameObj?.text || 'Brak nazwy'
    }
    return 'Brak nazwy'
  }

  const getProductPrice = product => {
    return product?.priceGross ? product.priceGross.toFixed(2) : '0.00'
  }

  const getProductQuantity = product => {
    return product?.quantity ?? 1
  }

  return (
    <div className='cardWrapper'>
      <div className='cardTop'>
        <div className='left'>
          <img src={`https://haproxy.abspos.pl/media/${order.logo}`} alt={`${order.localName} logo`} />
        </div>

        <div className='center'>
          <div className='date'>data: {formatDate(order.timestamp)}</div>
          <div className='zamowienieLabel'>zamówienie:</div>
          <div className='zamowienieValue'>{order.id ? order.id.substring(0, 8) : 'Brak ID'}</div>
        </div>

        <div className='right'>
          <div className='punkty'>
            {order.points > 0 ? '+' : ''}
            {order.points} pkt
          </div>
          <div className='kwotaLabel'>kwota:</div>
          <div className='kwotaValue'>{Number(order.sum).toFixed(2).replace('.', ',')}zł</div>

          <button className='details' onClick={() => setShowDetails(!showDetails)}>
            Szczegóły {showDetails ? '▲' : '▼'}
          </button>
        </div>
      </div>

      {showDetails && (
        <div className='detailsContainer'>
          {Array.isArray(order.products) && order.products.length > 0 ? (
            order.products.map((product, index) => (
              <div className='detailsRow' key={index}>
                <div className='productName'>{getProductName(product)}</div>
                <div className='productQty'>{getProductQuantity(product)}szt</div>
              </div>
            ))
          ) : (
            <div className='noProducts'>Brak pozycji w tym zamówieniu</div>
          )}
        </div>
      )}
    </div>
  )
}

export default OrderCard
